<template>
    <div class="main-wrapper">
        <layouts></layouts>

        <div class="page-wrapper">
            <litinglistcontent />
        </div>
    </div>
</template>
